<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import { numeric, required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import { pagingModel } from "@/models/core/pagingModel";
import DatePicker from "vue2-datepicker";
import Treeselect from "@riophae/vue-treeselect";
import { chuongTrinhModel } from "@/models/profession/chuongTrinh/chuongTrinhModel";
import { handleApiResponse } from "@/utils/api/apiResponseHandler";
import { STATUS_CODES } from "@/utils/api/apiConstants";
import VueMultiselect from "vue-multiselect";
import FormHoatDongChuongTrinh from "./formHoatDongChuongTrinh.vue";
import ActivityDetailList from "./activitiesDetailList.vue"; // Component mới cho List con
// import DeleteModal from "@/components/-modal.vue";
import {
  ButtonCore,
  ZoomableImage,
} from "@/components/widgets";

import { formatDate } from "@/utils/time/dateUtils.js";
import CustomTable from "@/components/custom-table.vue";
import SearchCard from "@/components/search-card.vue";

export default {
  page: {
    title: "Danh sách chương trình & sự kiện",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    ActivityDetailList,
    PageHeader,
    FormHoatDongChuongTrinh,
    CustomTable,
    SearchCard,
  },
  data() {
    return {
      title: "Danh sách chương trình & sự kiện",
      items: [
        {
          text: "Danh sách tin tức",
          href: "/danh-sach",
        },
        {
          text: "Danh sách",
          active: true,
        },
      ],
      list: [],
      fields: [
        {
          key: "_details",
          label: "",
          class: "td-expand",
          thClass: "hidden-sortable td-expand",
          thStyle: { width: "40px" },
        },

        {
          key: "STT",
          label: "STT",
          class: "td-stt",
          sortable: false,
          thClass: "hidden-sortable",
        },
        {
          key: "name",
          label: "Nội dung",
          class: "td-username",
          sortable: false,
          thStyle: "text-align:left ",
          thClass: "hidden-sortable text-uppercase",
        },
        {
          key: "name",
          label: "Địa chỉ",
          class: "td-content",
          sortable: false,
          thStyle: { align: "middle", width: "120px" },
          tdStyle: { align: "center" },
          thClass: "hidden-sortable text-center text-uppercase",
          tdClass: "text-center",
        },

        {
          key: "process",
          label: "Xử lý",
          class: "td-XuLy text-center",
          sortable: false,
          thClass: "hidden-sortable text-uppercase",
          thStyle: { width: "70px", minWidth: "60px" },
        },
      ],

      actionDefinitions: [
        {
          type: "edit",
          text: "Sửa",
          needsId: true,
          // iconClass: "fas fa-pencil-alt",
          variantClass: "btn-edit-core",
          // isRouterLink: true, // Đây là nút router-link
          customStyle: {
            height: "30px",
            alignItems: "center",
          },
          // basePath: "/danh-sach-tin-tuc/chi-tiet", // Path base cho router
        },
        {
          type: "delete",
          text: "Xóa",
          // iconClass: "fas fa-trash-alt",
          variantClass: "btn-deleteOutline-core",
          needsId: true, // Chỉ truyền item._id
          customStyle: {
            height: "30px",
            alignItems: "center",
          },
        },
        // {
        //   type: "approve",
        //   text: "Duyệt",
        //   iconClass: "fas fa-check",
        //   variantClass: "btn-accept-core",
        //   isDisable: false,
        //   shouldShow: (item) => item.status === "pending", // Chỉ hiện khi trạng thái là pending
        // },
      ],

      showProgramModal: false, // 1. Điều khiển trạng thái hiển thị Modal
      programToEdit: null, // 2. Dữ liệu chương trình đang chỉnh sửa (null nếu là tạo mới)

      formatDate: formatDate,

      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      showModal: false,
      showDeleteModal: false,
      submitted: false,
      sortBy: "age",
      filter: null,
      sortDesc: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      model: chuongTrinhModel.baseJson(),

      pagination: pagingModel.baseJson(),
      itemFilter: {
        content: null,
        isPublic: null,
        commonShort: null,
      },

      listCommon: [],
      // NEW: Các lựa chọn cho filter Trạng thái Xuất bản
      statusOptions: [
        { value: null, text: "Tất cả" },
        { value: true, text: "Xuất bản" },
        { value: false, text: "Không xuất bản" },
      ],

      treeView: [],

      showModalApproveAll: false,
      listApprove: [],
      showPreview: false,

      chuongTrinhSelected: null,
    };
  },

  created() {
    //   this.GetPagingParam();
    //    this.GetListParent();
    // this.getData();
  },
  computed: {
    searchFields() {
      return [
        {
          key: "content",
          label: "Nội dung",
          type: "text",
          placeholder: "Tìm kiếm theo tiêu đề sự kiện...",
          col: 12,
        },
      ];
    },
  },

  methods: {
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    // B. Kích hoạt Modal Tạo Mới
    handleCreateProgram() {
      this.programToEdit = null; // Reset dữ liệu về null (chế độ Tạo Mới)
      this.showProgramModal = true;
    },

    // C. Kích hoạt Modal Chỉnh Sửa
    handleEditProgram(program) {
      // Gán dữ liệu chương trình cần chỉnh sửa
      this.programToEdit = program;
      this.showProgramModal = true;
    },

    // D. Xử lý sau khi lưu thành công (program-saved được emit từ modal)
    handleProgramSaved() {
      // Đóng modal (đã được xử lý bên trong modal, nhưng an toàn hơn nếu gọi lại)
      this.showProgramModal = false;

      // Tải lại danh sách chương trình trong trang quản trị
      this.fnGetList();
    },

    async getData() {
      await this.$store
        .dispatch("profession/chuongTrinh/chuongTrinhStore/getAll")
        .then((res) => {
          if (
            res &&
            res.data &&
            STATUS_CODES.SUCCESS_VALUES.includes(res.code)
          ) {
            this.list = res.data.data;
            this.totalRows = res.data.totalRows;
          } else {
            this.list = [];
            this.totalRows = 0;
            // this.$store.dispatch("snackBarStore/addNotify", res);
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          }
        })
        .catch((error) => {
          console.error("Lỗi khi tải dữ liệu danh mục:", error);
          this.list = [];
          this.totalRows = 0;
          // this.$store.dispatch("snackBarStore/addNotify", {
          //   code: "ERROR",
          //   message: "Không thể tải dữ liệu danh mục.",
          // });
          this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: -1,
              message: "Không thể tải dữ liệu danh mục.",
            },
          });
        });
    },

    async handleDelete() {
      if (this.model._id != 0 && this.model._id != null && this.model._id) {
        await this.$store
          .dispatch("profession/chuongTrinh/chuongTrinhStore/delete", {
            _id: this.model._id,
          })
          .then((res) => {
            if (res.code === 0) {
              this.fnGetList();
              this.showDeleteModal = false;
            }
            var a = {
              message: res.message,
              code: res.code,
            };
            // console.log("LOG A : " ,a)
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          });
      }
    },

    myProvider(ctx) {
      // const params = {
      //   start: ctx.currentPage,
      //   limit: ctx.perPage,
      //   content: this.itemFilter.content,
      //   sortBy: this.sortBy,
      //   sortDesc: this.sortDesc,
      //   isAdmin: true,
      //   isPublic: this.itemFilter.isPublic?.value ?? null,
      // };

      this.loading = true;
      try {
        let promise = this.$store.dispatch(
          "profession/chuongTrinh/chuongTrinhStore/getAll"
        );
        return promise.then((resp) => {
          if (
            resp &&
            resp.data &&
            STATUS_CODES.SUCCESS_VALUES.includes(resp.code)
          ) {
            console.log("Response items list: ", resp.data);
            let items = resp.data;
            this.totalRows = resp.data.totalRows;
            this.numberOfElement = resp.data.length;
            this.loading = false;
            this.list = items;
            return (
              items.map((item) => ({
                ...item,
                _showDetails: false, // Mặc định ẩn
                _rowVariant:
                  item.hoatDongXuyenSuot.length > 0 ? "info-light" : "", // Tô màu nhẹ cho các hàng có chi tiết
              })) || []
            );
          } else {
            this.list = [];
            this.totalRows = 0;
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: resp.code,
                message: resp.message,
              },
            });
            return [];
          }
        });
      } catch (err) {
        console.error("Lỗi khi tải dữ liệu: ", err);
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message: "Không thể tải dữ liệu.",
          },
        });
      } finally {
        this.loading = false;
      }
    },

    handleShowDeleteModal(id) {
      this.model._id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (this.model._id != 0 && this.model._id != null && this.model._id) {
          console.log("LOG USER UPDATE NE : ", this.model);
          // Update model
          await this.$store
            .dispatch(
              "profession/chuongTrinh/chuongTrinhStore/update",
              this.model
            )
            .then((res) => {
              if (res.code === 0) {
                this.showModal = false;
                this.$refs.tblList.refresh();
              }
              this.$store.dispatch("snackBarStore/addNotify", {
                data: {
                  code: res.code,
                  message: res.message,
                },
              });
            });
        } else {
          // Create model
          console.log("LOG USER CREATE NE : ", this.model);
          await this.$store
            .dispatch(
              "profession/chuongTrinh/chuongTrinhStore/create",
              this.model
            )
            .then((res) => {
              if (res.code === 0) {
                this.fnGetList();
                this.showModal = false;
                this.model = {};
              }
              this.$store.dispatch("snackBarStore/addNotify", {
                data: {
                  code: res.code,
                  message: res.message,
                },
              });
            });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async handleUpdate(id) {
      // 1. Reset dữ liệu trước
      this.programToEdit = null;

      await this.$store
        .dispatch("profession/chuongTrinh/chuongTrinhStore/getById", {
          _id: id,
        })
        .then((res) => {
          if (res.code === 0) {
            // 2. Gán dữ liệu vào biến prop
            this.programToEdit = res.data; // (Lưu ý: Component Modal sẽ tự gọi chuongTrinhModel.toJson nếu cần)

            // 3. Mở Modal
            this.showProgramModal = true;
          } else {
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          }
        });
    },
    handleSearch() {
      // this.currentPage = 1;
      // this.getData();
      this.$refs.tblList.refresh();
    },
    handleClear() {
      this.itemFilter = {
        content: null,
        isPublic: null,
      };
      this.currentPage = 1;
    },

    async fnGetList() {
      this.$refs.tblList?.refresh();
    },
  },
  mounted() {
    // this.getListRole();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        // addCoQuanToModel()
        // this.saveValueToLocalStorage()
      },
    },

    showModal(status) {
      if (status == false) this.model = chuongTrinhModel.baseJson();
    },

    // model() {
    //   return this.model;
    // },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    },
  },
  filters: {
    // Filter cắt ngắn chuỗi
    truncate(value, length) {
      if (value.length > length) {
        return value.substring(0, length) + "...";
      }
      return value;
    },

    // Filter định dạng số (cần cài đặt thư viện format nếu số lớn)
  },
};
</script>

<template>
  <Layout>
    <div class="event-list-container">

      <!-- Header của trang danh sách -->
      <header class="header-wrapper">
        <div>
          <PageHeader :title="title" :items="items" class="p-0 m-0 border-0" />
        </div>
        <!-- Nút thêm mới chương trình -->
        <button @click="handleCreateProgram" class="btn-add">
          Thêm sự kiện mới
        </button>
      </header>

      <div class="row">
        <div class="col-12">
          <div class="card-premium">

            <!-- Bộ lọc tìm kiếm tái sử dụng chuẩn Bento -->
            <SearchCard :value="itemFilter" :fields="searchFields" @search="handleSearch" @clear="handleClear" />

            <!-- Điều khiển hiển thị số dòng của Bảng -->
            <div class="table-controls-bar">
              <div class="pagination-control-row">
                <span>Hiển thị</span>
                <select v-model="perPage" class="per-page-select">
                  <option v-for="opt in pageOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <span>dòng trên mỗi trang</span>
              </div>
            </div>

            <!-- Bảng quản trị (Sử dụng component CustomTable tái sử dụng) -->
            <CustomTable :items="myProvider" :fields="fields" striped bordered responsive="sm" :per-page="perPage"
              v-model="currentPage" :number-of-element="numberOfElement" :total-rows="totalRows" ref="tblList"
              primary-key="_id">

              <!-- 1. CỘT DETAILS (Nút Expand) -->
              <template #cell(_details)="row">
                <button type="button" @click="row.toggleDetails" class="btn-expand">
                  <span :class="['isax', row.detailsShowing ? 'isax-arrow-up-1' : 'isax-arrow-down']"></span>
                </button>
              </template>

              <!-- 2. CỘT TÊN CHƯƠNG TRÌNH / NỘI DUNG -->
              <template v-slot:cell(name)="data">
                <div v-if="data.item.name" class="font-semibold text-left">
                  {{ data.item.name }}
                </div>
              </template>

              <!-- 3. CỘT XỬ LÝ -->
              <template v-slot:cell(process)="data">
                <div class="action-buttons-flex">
                  <!-- Nút Sửa -->
                  <button type="button" class="btn-edit" @click="handleUpdate(data.item._id)"
                    title="Chỉnh sửa thông tin"></button>

                  <!-- Nút Xoá -->
                  <button type="button" class="btn-del" @click="handleShowDeleteModal(data.item._id)"
                    title="Xóa chương trình"></button>
                </div>
              </template>

              <!-- 4. ROW DETAILS (NỘI DUNG MỞ RỘNG) -->
              <template #row-details="row">
                <b-card class="activity-details-card">
                  <div class="row">
                    <div class="col-12">
                      <h5 class="fw-bold mb-3 text-success-custom text-uppercase letter-spacing-0.05em">
                        Chi tiết Hoạt động của sự kiện:
                      </h5>

                      <!-- KHU VỰC HIỂN THỊ CÁC LIST HOẠT ĐỘNG CON -->
                      <ActivityDetailList :activities="row.item.hoatDongXuyenSuot" title="Hoạt động Xuyên suốt"
                        class="mb-3" />

                      <ActivityDetailList :activities="row.item.truocLeHoi" title="Hoạt động Chính" class="mb-3" />
                      <ActivityDetailList :activities="row.item.hoatDongTheoKhungSo" title="Hoạt động Theo Khung giờ"
                        class="mb-3" />
                      <ActivityDetailList :activities="row.item.hoatDongHuongUng" title="Hoạt động Hưởng ứng" />
                    </div>
                  </div>
                </b-card>
              </template>
            </CustomTable>

          </div>
        </div>
      </div>

      <!-- <DeleteModal modal-id="custom_delete_modal" title="Xóa thông tin sự kiện"
        message="Dữ liệu sự kiện sau khi xóa sẽ <b>không thể hồi phục</b>.<br>Bạn có chắc chắn muốn xóa sự kiện này không?"
        confirm-text="ĐỒNG Ý XÓA" cancel-text="HỦY BỎ" @confirm="handleDelete" /> -->

      <!-- MODAL XÓA SỰ KIỆN -->
      <b-modal v-model="showDeleteModal" centered title="Xóa dữ liệu"
        title-class="modal-delete-title text-danger-custom" no-close-on-backdrop>
        <p class="text-left font-body">Dữ liệu xóa sẽ không được phục hồi!</p>
        <template #modal-footer>
          <button type="button" class="btn-close-form" @click="showDeleteModal = false">
            Đóng
          </button>
          <button type="button" class="btn-del" @click="handleDelete">
            Xóa
          </button>
        </template>
      </b-modal>

      <!-- FORM THÊM/SỬA SỰ KIỆN -->
      <FormHoatDongChuongTrinh v-model="showProgramModal" :programData="programToEdit"
        @program-saved="handleProgramSaved" />
    </div>
  </Layout>
</template>

<style scoped>
/* ======================== CHỦ ĐỀ CHUNG & KHUNG BÊN NGOÀI ======================== */
.event-list-container {
  padding: 0 12px;
}

.header-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  gap: 16px;
}

@media (min-width: 768px) {
  .header-wrapper {
    flex-direction: row;
    align-items: flex-end;
  }
}

/* Nút thêm mới */
.add-btn-style {
  padding: 12px 24px;
  border-radius: 8px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
  transition: all 0.2s ease-in-out;
}

.add-btn-style:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.25);
  transform: translateY(-1px);
}

.icon-btn-add {
  font-size: 18px;
}

/* ======================== THẺ CARD CAO CẤP ======================== */
.card-premium {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid rgba(187, 202, 186, 0.3);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 24px;
}

/* Điều khiển dòng hiển thị */
.table-controls-bar {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.1);
  background-color: rgba(241, 245, 235, 0.3);
}

.pagination-control-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  color: var(--color-public-text-body, #374151);
}

.per-page-select {
  border: 1px solid rgba(187, 202, 186, 0.5);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  outline: none;
  background-color: #ffffff;
  font-weight: 600;
  color: var(--color-public-text-body, #374151);
}

/* Hộp nút thao tác xử lý trong dòng bảng */
.action-buttons-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(187, 202, 186, 0.3);
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-success-custom {
  color: var(--color-status-success, #4caf50);
}

.btn-success-custom:hover {
  background-color: rgba(76, 175, 80, 0.08);
  border-color: var(--color-status-success, #4caf50);
}

.btn-danger-custom {
  color: var(--color-status-error, #d32f2f);
}

.btn-danger-custom:hover {
  background-color: rgba(211, 47, 47, 0.08);
  border-color: var(--color-status-error, #d32f2f);
}

/* Custom expand button */
.btn-expand {
  background: none !important;
  border: none !important;
  color: var(--color-public-primary, #2e7d32) !important;
  padding: 0;
  width: 30px;
  height: 30px;
  font-size: 1.1rem;
  box-shadow: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.btn-expand:hover {
  transform: scale(1.1);
}

/* Details row styling */
.activity-details-card {
  border: 1px solid rgba(187, 202, 186, 0.2) !important;
  border-radius: 8px !important;
  background-color: rgba(241, 245, 235, 0.2) !important;
  margin: 10px 0;
  padding: 15px;
}

.text-success-custom {
  color: var(--color-public-primary, #2e7d32);
}

/* Modal Title */
::v-deep .modal-delete-title {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.text-danger-custom {
  color: var(--color-status-error, #d32f2f) !important;
}
</style>
